$(document).on 'click', '.link', ->
    url = $(@).attr 'href'
    deactivateTexts()
    loadPage(url)
    false

# window.onbeforeunload = (e) ->
#   return 'Máte rozdělanou práci. Nechcete si ji uložit?'


showLoader = ->
  $('#loader').addClass 'shown'

$('#loader').click ->
  $(@).removeClass('shown')
  return

hideLoader = ->
  $('#loader').removeClass('shown')
  return

showSmallLoader = ->
  $('#small_loader').addClass('shown')
  return

$('#small_loader').click ->
  hideSmallLoader()
  return

hideSmallLoader = ->
  $('#small_loader').removeClass 'shown'
  return

$('input#hide_used, input#show_all_photos, input#show_friends_photos').change ->
  photoContainer.reload()


loadPage = (url, scroll = true) ->

    console.log url, scroll

    showLoader()
    $.ajax(
      url:  '/ajax/app/load_page/'
      type: 'POST'
      dataType: 'JSON'
      data: 
        url: url
        actual_url: window.location.pathname
    ).done((data) ->
      hideLoader()

      # console.log data

      can_reload = data.status

       

      if upload_in_progress 
        confirm 'probiha upload pockejte az bude hotovy...'
        can_reload = false

      if can_reload
        
        if data.reload
          # url = data.reload
          # loadPage(url)
          window.location.href = data.reload

        if data.redirect2url
          url = data.redirect2url

        frames = []
        objects = []

        if $('#user_page_container').length
          if $('.user_page').hasClass 'active'
            userPageContainer.reload()



        history.pushState({}, data.title, url);
        document.title = data.title;


        $('#app').html data.html_output
        $("#overlay_test").addTouch()
        
        $('input[accept]').each ->
          $(@).removeAttr('accept')

        if $('#calendarium_container').length
          if $('.calendarium').hasClass 'active'
            calendariumContainer.reload()
        
        if $('#themes_container').length
          if $('.themes').hasClass 'active'
            themesContainer.reload()

        tooltip = new Tooltip
            theme: "dark"
            delay: 250

        $('.page').pageOverlay()
        # calcPrice()
        reload_prices()

        # vybehne nahoru pouze pri ceste overview -> detail
        clickable_drop = false

        $('.layout.title_layout').addClass 'inactive'

        if $('#app_overview.multiproduct').length
          console.log 'reload'
          layoutContainer.reload()

        if $('#page_detail.multiproduct').length
          console.log 'reload'
          layoutContainer.reload()

        if data.app_url.app_page == 'strana'

          clickable_drop = true
          doc_width = $(document).width()

          if $(window).scrollTop() > 1000 and scroll == true and $(window).width() < 700
            $('html,body').animate { scrollTop: $('#app_container').offset().top }, 'slow'

          if $('.layout').length
            $('.layout').removeClass 'active'
            $('.layout').removeClass 'hidden'
            
            $('.layout[data-layout_id='+data.page_data.layout+']').addClass 'active'
            


            $('.layout_cont').each ->
              $cont = $(@)
              $body = $cont.find('.layout_body')

              # zkontroluj jestli má být otevřený podle data-open nebo aktivního layoutu
              hasActiveLayout = $body.find('.layout.active').length > 0
              isOpen = $cont.data('open') == 1 or hasActiveLayout

              console.log(hasActiveLayout, isOpen)


              if not isOpen
                $body.hide()
              else
                $cont.addClass 'open'
                $body.show()
            # console.log data.app_url.app_var

            if data.app_url.app_var == '1'
              $('.layout.title_layout').removeClass 'inactive'

          if $('.background').length
            $('.background').removeClass 'active'
            $('.background[data-background_id='+data.page_data.background_image+']').addClass 'active'



          # pokud neni aktivni nejaky text
          if parseInt($('#active_text').val()) == 0
            textsContainer.reload(0, data.app_url.app_var);
          else 
            if $('#active_text').val() > 0
              $('.object_in_page[data-object_id='+$('#active_text').val()+']').addClass 'active'


        else   
          # na prehledu se reloadnou dycy i ceny
          textsContainer.reload(0, 0);



        #  overview
        $('.frame').each ->
          frames[$(@).attr('id')] = $(@).frameEvents({drop: true, clickable_drop: clickable_drop})
          return


        $('.object_in_page').each ->
          objects[$(@).data('object_id')] = $(@).objectEvents({parent: $(@).parent()})
          return

    

        # Inicializace – klidně s malým odkladem po prvním paintu
        $('img[data-full_image!=""]').each ->
          $img = $(@)
          setTimeout (-> upgradeToFull($img)), 200
          return


        uploader_id = 0
        uploader = []

        queed_files = 0
        uploaded_files = 0
        total_bytes = 0.001
        last_upload_value = 0
        total_bytes_sent = 0
        file_bytes_sent = []

        $('.dropzone_add_new_page').each ->


          uploader_id = uploader_id + 1

          progressbar = $(@).find('.upload_progress')
          uploader[uploader_id] = $(@).dropzone
              previewTemplate: '
                  <div class="dz-preview dz-file-preview">
                      <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                  </div>
              ',
              
              uploadMultiple: true

              parallelUploads: 1

              timeout: 3600000

              params:   
                  enhance: $('input[name=auto_enhance]').val()
              sending: (file, xhr, formData) ->
                  formData.append('addPage', true);
              init: ->
                  _this = this
                  this.on 'addedfile', (file) ->
                      progressbar.show()
                      total_bytes = total_bytes + file.size
                      queed_files = queed_files + 1
                      file_bytes_sent[file.name] = 0
                      return
                  this.on 'uploadprogress', (file, progress, bytesSent) ->
                   
                    total_bytes_sent = total_bytes_sent + (bytesSent - last_upload_value)
                    file_bytes_sent[file.name] = parseInt(file_bytes_sent[file.name]) + (bytesSent - last_upload_value)
                    last_upload_value = bytesSent

                    return 
                  this.on 'success', (file, out) ->
                      # loadPage()
                      # console.log out
                      console.log file_bytes_sent[file.name]
                      total_bytes_sent = total_bytes_sent + (file.size - file_bytes_sent[file.name])
                      uploaded_files = uploaded_files + 1
                      if out == 'upload_error'
                        new swal
                          title: 'Neočekávaná příloha'
                          text: 'Jejda, s tímto datovým typem se asi neumíme poprat. Očekávaná data jsou: jpg, jpeg, png'
                          icon: 'error'
                          confirmButtonText: 'Chápu!'
                          showCancelButton: false
                      return
    
                  this.on 'complete', ->
                      if uploaded_files == queed_files
                          uploaded_files = 0
                          queed_files = 0
                          $('.dz-preview').remove();
                          photoContainer.reload()
                          progressbar.find('.progress').css 'width', '0%'
                          progressbar.find('.progress_message').text ''
                          progressbar.hide()
                          setTimeout ->
                            loadPage()
                            return
                          , 110
                      return
                  this.on 'totaluploadprogress', (uploadProgress, totalBytes, totalBytesSent) ->
                    console.log uploadProgress, totalBytes, totalBytesSent
                    progressbar.show()

                    progress = (total_bytes_sent / total_bytes) * 100
                    progressbar.find('.progress').css 'width', progress+'%'
                    progressbar.find('.progress_message').text uploaded_files + ' / ' + queed_files 
                    return

                  return

          return
        

        return frames
        
      else
        # history.pushState({}, data.title, url);
        # document.title = data.title;
        # $('#app').html data.html_output
        return


      return
    ).fail (jqXHR) ->
      console.warn jqXHR.responseText
      return
    return

